<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t('distributorcollectionreport') }}</div>

      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getDistributorReportFromDate"
                  v-on:click="onDistributorReportDateHandler({ event: null, name: 'fromDate' })"
                >✖</button>
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  @selected="onDistributorReportDateHandler({ event: $event, name: 'fromDate' })"
                  :value="getDistributorReportFromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getDistributorReportFromDate ? 'active': ''">{{ $tc('showFromDate') }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button
                  class="btn-clearDate"
                  v-if="getDistributorReportToDate"
                  v-on:click="onDistributorReportDateHandler({ event: null, name: 'toDate' })"
                >✖</button>-->
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  @selected="onDistributorReportDateHandler({ event: $event, name: 'toDate' })"
                  :value="getDistributorReportToDate"
                  v-validate="'required'"
                  disabled
                ></Datepicker>
                <label :class="getDistributorReportToDate ? 'active': ''">{{ $tc('showToDate') }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getDistributorReportSelectedCinema && getDistributorReportSelectedCinema.length > 0 ? 'shift-up' : ''"
              >{{ $tc('selectCinema') }}</label>
              <b-dropdown
                :text="getDistributorReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getCinemasList"
                  :key="dropdownIndex+dropdownItem.cine_name"
                  @click="onDistributorReportDropdownHandler({ event: $event, name:'isCinema',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div v-if="!getDistributorReportsIsDistributor" class="col-lg-6 col-xl-3 mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getDistributorReportSelectedDistributor && getDistributorReportSelectedDistributor.length > 0 ? 'shift-up' : ''"
              >Select Distributor</label>
              <b-dropdown
                :text="getDistributorReportSelectedDistributor"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getDistributorReportDropdownList"
                  :key="dropdownIndex+dropdownItem.d_company_name"
                  @click="onDistributorReportDropdownHandler({ event: $event, name:'isDistributor',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.d_company_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getDistributorReportSelectedMovie && getDistributorReportSelectedMovie.length > 0 ? 'shift-up' : ''"
              >Select Movie</label>
              <b-dropdown
                :text="getDistributorReportSelectedMovie"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getDistributorReportMoviesList"
                  :key="dropdownIndex+dropdownItem.movie_title"
                  @click="onDistributorReportDropdownHandler({ event: $event, name:'isMovie',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.movie_title }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent.stop="fetchDistributorReportList"
            >{{ $tc('fetch') }} {{ $tc('report') }}</button>
          </div>
        </div>
      </div>

      <div class="swc-report" v-if="getDistributorReportList.length === 0">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th>Show Time and Class</th>
              <th>Screen Name</th>
              <th>Ticket Rate</th>
              <th>Ticket Sold</th>
              <th>Gross Book Office Revenue</th>
              <th>Service Charge</th>
              <th>Net Collection</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="7">
                <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="getDistributorReportList.length > 0"
        v-for="(MainItem, MainItemIndex) in getDistributorReportList"
        :key="MainItemIndex+MainItem.t_show_date"
        class="swc-report"
      >
        <p>Date: {{ MainItem.t_show_date | dateparse }} &nbsp;&nbsp;&nbsp; Week: {{ getDateWeekData ? getDateWeekData['weekStart']: '' }} &nbsp;&nbsp;&nbsp; Day: {{ MainItem.t_show_date | daynumber }}&nbsp;{{ MainItem.t_show_date | getDay }}</p>
        <table
          v-for="(DistributorReport, DistributorReportIndex) in MainItem.ShowsList"
          :key="DistributorReportIndex+'Distributors'"
          class="swc-report-table"
          border="1"
        >
          <thead v-if="DistributorReportIndex == 0">
            <tr>
              <th>Show Time and Class</th>
              <th>Screen Name</th>
              <th>Ticket Rate</th>
              <th>Ticket Sold</th>
              <th>Gross Book Office Revenue</th>
              <th
                v-for="(DistributorReportCharge, DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="DistributorReportChargeIndex+DistributorReportCharge.ct_name"
              >{{ DistributorReportCharge.ct_name }}</th>
              <!-- <th>CGST</th>
                <th>SGST</th>
                <th>Service Charge</th>
              <th>3D Charge</th>-->
              <th>Net Collection</th>
            </tr>
          </thead>
          <tbody
            v-for="(Screen, ScreenIndex) in DistributorReport.Screens"
            :key="ScreenIndex+'Screens'"
          >
            <tr
              v-for="(Show, ShowIndex) in Screen.Shows"
              :key="ShowIndex+Show.rating+Show.sst_seat_type"
            >
              <td>{{ Show.sst_seat_type }}</td>
              <td>{{ Show.screen_name }}</td>
              <td>{{ Show.t_gross_amount }}</td>
              <td>{{ Show['ShowNo'] ? Show['ShowNo'] : '-' }}</td>
              <td>{{ Show['ShowNo'] ? (parseFloat(Show['ShowNo']) * parseFloat(Show.t_gross_amount)).toFixed(2) : '-' }}</td>
              <td
                v-for="(DistributorReportCharge, DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="DistributorReportChargeIndex+DistributorReportCharge.ct_name"
              >{{ Show[DistributorReportCharge.ct_name+'_'+DistributorReportCharge.charge_type_id] && Show['ShowNo'] ? (parseFloat(Show[DistributorReportCharge.ct_name+'_'+DistributorReportCharge.charge_type_id]) * parseFloat(Show['ShowNo'])).toFixed(2): '-' }}</td>
              <!-- <td>0.00</td>
              <td>0.00</td>
              <td>0.00</td>
              <td>0.00</td>-->
              <td>{{ Show['ShowNo'] ? (parseFloat(Show['ShowNo']) * parseFloat(Show.t_net_amount)).toFixed(2) : '-' }}</td>
            </tr>

            <tr>
              <td>
                <strong>Show Time: {{ Screen.Shows.length > 0 ? Screen.Shows[0].t_show_time : '-'}}</strong>
              </td>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong>{{ Screen.Shows.reduce((accumulator, { ShowNo }) => accumulator + parseFloat(ShowNo),0).toFixed(2) }}</strong>
              </td>
              <td>
                <strong>{{ Screen.Shows.reduce((accumulator, { t_gross_amount, ShowNo })=> accumulator + (parseFloat(t_gross_amount) * parseFloat(ShowNo)),0).toFixed(2) }}</strong>
              </td>
              <td
                v-for="(DistributorReportCharge, DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="DistributorReportChargeIndex+DistributorReportCharge.ct_name+DistributorReportCharge.charge_type_id"
              >
                <strong>{{ Screen.Shows.reduce((accumulator, obj)=> accumulator + (obj[DistributorReportCharge.ct_name+'_'+DistributorReportCharge.charge_type_id] * parseFloat(obj.ShowNo)),0).toFixed(2) == 'NaN' ? '-': Screen.Shows.reduce((accumulator, obj)=> accumulator + (obj[DistributorReportCharge.ct_name+'_'+DistributorReportCharge.charge_type_id] * parseFloat(obj.ShowNo)),0).toFixed(2) }}</strong>
              </td>

              <td>
                <strong>{{ Screen.Shows.reduce((accumulator, { t_net_amount, ShowNo })=> accumulator + (parseFloat(t_net_amount) * parseFloat(ShowNo)),0).toFixed(2) }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="swc-report-table" border="1">
          <tbody>
            <!-- TODAYS TOTAL -->
            <tr v-if="MainItem.TodaysTotal.length > 0">
              <td colspan="3" class="text-right">Today's Total :</td>

              <td>{{ MainItem.TodaysTotal[0].TicketSold }}</td>
              <td>{{ MainItem.TodaysTotal[0].GrossRevenue.toFixed(2) }}</td>
              <td
                v-for="(DistributorReportCharge, DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="DistributorReportChargeIndex+DistributorReportCharge.ct_name+DistributorReportCharge.charge_type_id+'One'"
              >{{ (MainItem.TodaysTotal[0][DistributorReportCharge.ct_name+'_'+DistributorReportCharge.charge_type_id]).toFixed(2) }}</td>
              <td>{{ MainItem.TodaysTotal[0].NetRevenue.toFixed(2) }}</td>
            </tr>

            <!-- PREVIOUS TOTAL -->
            <tr v-if="MainItem.PreviousTotal.length > 0">
              <td colspan="3" class="text-right">Previous Total :</td>
              <td>{{ MainItem.PreviousTotal[0].TicketSold }}</td>
              <td>{{ MainItem.PreviousTotal[0].GrossRevenue.toFixed(2) }}</td>
              <td
                v-for="(DistributorReportCharge, DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="DistributorReportChargeIndex+DistributorReportCharge.ct_name+'TWO'"
              >{{ (MainItem.PreviousTotal[0][DistributorReportCharge.ct_name+'_'+DistributorReportCharge.charge_type_id]).toFixed(2) }}</td>
              <td>{{ MainItem.PreviousTotal[0].NetRevenue.toFixed(2) }}</td>
            </tr>

            <!-- GRAND TOTAL -->
            <tr v-if="MainItem.PreviousTotal.length > 0 || MainItem.TodaysTotal.length > 0">
              <td colspan="3" class="text-right">Grand Total :</td>
              <td>{{ MainItem.TodaysTotal[0].TicketSold + MainItem.PreviousTotal[0].TicketSold }}</td>
              <td>{{ (MainItem.TodaysTotal[0].GrossRevenue + MainItem.PreviousTotal[0].GrossRevenue).toFixed(2) }}</td>
              <td
                v-for="(DistributorReportCharge, DistributorReportChargeIndex) in getDistributorReportChargeList"
                :key="DistributorReportChargeIndex+DistributorReportCharge.ct_name+'THREE'"
              >{{ (MainItem.TodaysTotal[0][DistributorReportCharge.ct_name+'_'+DistributorReportCharge.charge_type_id] + MainItem.PreviousTotal[0][DistributorReportCharge.ct_name+'_'+DistributorReportCharge.charge_type_id]).toFixed(2) }}</td>
              <td>{{ (MainItem.TodaysTotal[0].NetRevenue + MainItem.PreviousTotal[0].NetRevenue).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>

        <table v-if="true" class="swc-report-table mt-4" border="1">
          <thead>
            <tr class="bg-lightgrey">
              <td>Day</td>
              <td>Shows</td>
              <td>Attendence</td>
              <td>Housefull Nett</td>
              <td>Nett</td>
              <td>%</td>
            </tr>
          </thead>
          <tbody
            v-for="(Daysitem, DaysIndex) in MainItem.DayCollectionArray"
            :key="DaysIndex+Daysitem.date"
          >
            <tr v-if="DaysIndex <= MainItemIndex">
              <td>{{ Daysitem.date | daydate }}</td>
              <td>{{ Daysitem.Shows }}</td>
              <td>{{ Daysitem.Attendance }}</td>
              <td>{{ Daysitem.HousefullNett.toFixed(2) }}</td>
              <td>{{ Daysitem.Nett.toFixed(2) }}</td>
              <td>{{ ((Daysitem.Nett / Daysitem.HousefullNett) * 100).toFixed(2) }}</td>
            </tr>
            <tr v-else>
              <td>{{ Daysitem.date | daydate }}</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
          </tbody>
          <tbody>
            <!-- <tr class="bg-lightgrey">
              <th>Total :</th>
              <th>49</th>
              <th>5,627</th>
              <th>2,602,318.43</th>
              <th>629,500.66</th>
              <th>27.58</th>
            </tr>-->
            <tr>
              <td>Total :</td>
              <td>{{ MainItem.WeeksCollection.Shows }}</td>
              <td>{{ MainItem.WeeksCollection.Attendance }}</td>
              <td>{{ MainItem.WeeksCollection.HousefullNett.toFixed(2) }}</td>
              <td>{{ MainItem.WeeksCollection.Nett.toFixed(2) }}</td>
              <td>{{ ((MainItem.WeeksCollection.Nett.toFixed(2) / MainItem.WeeksCollection.HousefullNett.toFixed(2)) * 100).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>

        <table v-if="MainItem.WeeksCollection" class="swc-report-table mt-4" border="1">
          <thead>
            <tr class="bg-lightgrey">
              <td>Week</td>
              <td>Shows</td>
              <td>Attendence</td>
              <td>Housefull Nett</td>
              <td>Nett</td>
              <td>%</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(CountItem, CountIndex) in 7" :key="CountIndex+'Count'">
              <td>{{ CountItem }}</td>
              <td>{{ CountItem === getDateWeekData['weekStart'] ? MainItem.WeeksCollection.Shows : '' }}</td>
              <td>{{ CountItem === getDateWeekData['weekStart'] ? MainItem.WeeksCollection.Attendance : '' }}</td>
              <td>{{ CountItem === getDateWeekData['weekStart'] ? MainItem.WeeksCollection.HousefullNett.toFixed(2) : '' }}</td>
              <td>{{ CountItem === getDateWeekData['weekStart'] ? MainItem.WeeksCollection.Nett.toFixed(2) : '' }}</td>
              <td>{{ CountItem === getDateWeekData['weekStart'] ? ((MainItem.WeeksCollection.Nett.toFixed(2) / MainItem.WeeksCollection.HousefullNett.toFixed(2)) * 100).toFixed(2) : '' }}</td>
            </tr>

            <tr class="bg-lightgrey">
              <td>Total :</td>
              <td>{{ MainItem.WeeksCollection.Shows }}</td>
              <td>{{ MainItem.WeeksCollection.Attendance }}</td>
              <td>{{ MainItem.WeeksCollection.HousefullNett.toFixed(2) }}</td>
              <td>{{ MainItem.WeeksCollection.Nett.toFixed(2) }}</td>
              <td>{{ ((MainItem.WeeksCollection.Nett.toFixed(2) / MainItem.WeeksCollection.HousefullNett.toFixed(2)) * 100).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>

        <table class="swc-report-table mt-4" border="1">
          <thead>
            <tr class="bg-lightrey">
              <th :colspan="MainItem.distributorDeductions.length">Deductions (Rs.)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="MainItem.distributorDeductions.length > 0">
              <td
                v-for="(DeductionItem, DeductionIndex) in MainItem.distributorDeductions"
                :key="DeductionIndex+'MainDeduction'"
                class="p-0"
              >
                <table class="w-100">
                  <tr v-for="(Item, Index) in DeductionItem" :key="Index+Item.dd_deduction_label">
                    <td class="text-left">{{ Item.dd_deduction_label }} :</td>
                    <td class="text-left">{{ Item.dd_deduction_value }}</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr v-if="MainItem.distributorDeductions.length === 0">
              <td class="p-0">No Distributor Deduction Found</td>
            </tr>
          </tbody>
          <tbody>
            <tr class="bg-lightgrey">
              <td :colspan="MainItem.distributorDeductions.length" class="p-0">
                <table class="w-100">
                  <tr>
                    <td
                      class="text-left"
                    >Total Nett: {{ (MainItem.TodaysTotal[0].NetRevenue + MainItem.PreviousTotal[0].NetRevenue).toFixed(2) }}</td>
                    <td>Total Deductions: {{ MainItem.totalDeductions }}</td>
                    <td
                      class="text-right"
                    >{{ ((MainItem.TodaysTotal[0].NetRevenue + MainItem.PreviousTotal[0].NetRevenue) - MainItem.totalDeductions).toFixed(2) }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="getDistributorReportList.length > 0"
        class="d-flex justify-content-end mt-5 align-items-center"
      >
        <div>Download as:</div>
        <a
          v-if="getDistributorPDFFileName"
          :href="BASE_URL+getDistributorPDFFileName"
          target="_blank"
          download
          title="Download as PDF"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>

        <a
          v-if="getDistributorExcelFileName"
          :href="BASE_URL+getDistributorExcelFileName"
          target="_blank"
          title="Download as Excel"
          download
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>
    </div>

    <div v-if="false" class="white-wrapper">
      <div class="bg-lightgrey font-weight-bold py-1 w-100 text-center">Collection Summary</div>

      <div class="swc-report mt-4">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th colspan="5">TODAY</th>
            </tr>
            <tr>
              <td>Show</td>
              <td>Aud</td>
              <td>Nett</td>
              <td>BOR</td>
              <td>%</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>9:05 AM</th>
              <td>61</td>
              <td>4341.84</td>
              <td>6,388.00</td>
              <td>32.85</td>
            </tr>
            <tr>
              <th></th>
              <th>514</th>
              <th>54876.26</th>
              <th>77,142.00</th>
              <th>30.80</th>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="swc-report mt-4">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th colspan="6">THIS WEEK</th>
            </tr>
            <tr>
              <td>Day</td>
              <td>Sh.</td>
              <td>Aud</td>
              <td>Nett</td>
              <td>BOR</td>
              <td>%</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Fri</th>
              <td>9</td>
              <td>451</td>
              <td>68461.55</td>
              <td>91,886.00</td>
              <td>27.00</td>
            </tr>
            <tr>
              <th></th>
              <th>93</th>
              <th>4652</th>
              <th>561,777.44</th>
              <th>774,952.00</th>
              <th>38.70</th>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="swc-report mt-4">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th colspan="5">THIS RUN (ALL SCREENS)</th>
            </tr>
            <tr>
              <td>Wk</td>
              <td>Aud.</td>
              <td>Nett</td>
              <td>BOR</td>
              <td>%</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>1</th>
              <td>4652</td>
              <td>561777.44</td>
              <td>774,952.00</td>
              <td>38.70</td>
            </tr>
            <tr>
              <th></th>
              <th>4652</th>
              <th>561777.44</th>
              <th>774,952.00</th>
              <th>38.70</th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { movieWeekEnd } from "@/helper/collection";
import moment from "moment";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      // GET LIST ONLY FROM MASTER STORE
      "getCinemasList",

      // Selected Dropdowns
      "getDistributorReportSelectedMovie",
      "getDistributorReportSelectedCinema",
      "getDistributorReportSelectedDistributor",
      // Flags
      "getDistributorReportsIsCinema",
      "getDistributorReportsIsDistributor",
      // Selected Dates
      "getDistributorReportToDate",
      "getDistributorReportFromDate",
      // Get List
      "getDistributorReportList",
      "getDistributorReportDropdownList",
      "getDistributorReportMoviesList",
      "getDistributorReportChargeList",
      // GET EXCEL FILE
      "getDistributorExcelFileName",
      // PDF
      "getDistributorPDFFileName",

      // GET WEEK DATA
      "getDateWeekData"
    ])
  },
  beforeMount() {
    // console.log(
    //   "movieWeekEnd :",
    //   movieWeekEnd(new Date("2020-02-23T17:10:05+05:30"))
    // );
    let distributorId = this.secureStore.get("USINFO")["distributor_id"];
    console.log("dis::::::::::::: :", distributorId);
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.onDistributorReportFlagHandler({
      event: null,
      name: "isCinema",
      value: cinemaId
    });
    if (distributorId) {
      this.onDistributorReportFlagHandler({
        event: null,
        name: "isDistributor",
        value: distributorId
      });
    }
    // this.onDistributorReportFlagHandler({
    //   event: null,
    //   name: "isCountry",
    //   value: this.secureStore.get("BRGLOPCO") || null
    // });
    this.fetchCinemasList({ cinemaId });
    this.fetchReportDistributorsList();
    // this.fetchDistributorsActiveMasterMovie();
  },
  mounted() {},
  methods: {
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      // "fetchDistributorsList",
      // "fetchDistributorsActiveMasterMovie",
      // FETCH LIST ONLY
      "fetchReportDistributorsList",
      "fetchDistributorReportList",
      "onDistributorReportDateHandler",
      "onDistributorReportDropdownHandler",
      "onDistributorReportFlagHandler",
      "onResetDistributorStoreState"
    ])
  },
  beforeDestroy: async function() {
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getDistributorExcelFileName
    });
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getDistributorPDFFileName
    });
    await this.onResetDistributorStoreState();
  }
};
</script>
  


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/distributorCollectionReport.vue